// packages/world-model/src/traits/clothing/index.ts

export * from './clothingTrait';
